import { render, staticRenderFns } from "./MeasurementBar.vue?vue&type=template&id=e5cd1948&scoped=true&"
import script from "./MeasurementBar.vue?vue&type=script&lang=js&"
export * from "./MeasurementBar.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementBar.vue?vue&type=style&index=0&id=e5cd1948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd1948",
  null
  
)

export default component.exports